import React, { useEffect, useContext, useState } from 'react'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ReportContext from '@/custom/context/report/reportContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { useTranslation } from 'react-i18next'

const ReportDisplay = (props) => {
    const formik = props.formik
    const fieldsToShow = props.fieldsToShow
    const [isLoading, setIsLoading] = useState(true)
    const reportContext = useContext(ReportContext)
    const { t } = useTranslation()
    const {
        reports_data,
        getAllReportDisplay,
        getAllReportDownload,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
    } = reportContext

    const [tableBody, setTableBody] = useState([])
    const searchInfo = props.searchInfo
        ? { formik: formik, ...props.searchInfo }
        : {}

    let tableValues = []

    if (
        reports_data &&
        reports_data?.requests?.report === 'closed_auction_completion_report'
    ) {
        fieldsToShow.map((item) =>
            item?.formFields?.map((field) => {
                if (
                    field?.group?.indexOf(
                        reports_data?.requests?.report.toString()
                    ) !== -1 &&
                    reports_data.requests?.fields.includes(
                        field?.field.toString()
                    )
                ) {
                    tableValues.push(field)
                }
            })
        )
    } else if (reports_data) {
        tableValues = fieldsToShow.filter(
            (field) =>
                field?.group?.indexOf(
                    reports_data.requests.report.toString()
                ) !== -1 && reports_data.requests.fields.includes(field.field)
        )
    }

    const tableActions = []

    useEffect(() => {
        if (reports_data?.records?.length == 0) setIsLoading(false)
        if (reports_data) {
            console.log(reports_data, 'rrrrrrrrrr')
            if (
                formik?.order2 === 'asc' &&
                formik?.values.orderby2 &&
                reports_data?.requests?.report ===
                    'closed_auction_completion_report'
            ) {
                let orderby = formik.values.orderby2
                reports_data.records.sort(
                    (a, b) => parseInt(a[orderby]) - parseInt(b[orderby])
                )
                setTableBody(
                    reports_data?.records?.length ? reports_data.records : []
                )
            } else if (
                formik.values.order2 === 'desc' &&
                formik.values.orderby2 &&
                reports_data?.requests?.report ===
                    'closed_auction_completion_report'
            ) {
                let orderby = formik.values.orderby2
                reports_data.records.sort(
                    (a, b) => parseInt(b[orderby]) - parseInt(a[orderby])
                )
                setTableBody(
                    reports_data?.records?.length ? reports_data.records : []
                )
            } else {
                setTableBody(
                    reports_data?.records?.length ? reports_data.records : []
                )
            }
        }
    }, [reports_data])

    useEffect(() => {
        if (tableBody.length) {
            tableBody.map((data, index) =>
                data.paid === 1 ? (data.paid = 'Yes') : (data.paid = 'No')
            )
            setIsLoading(false)
        }
    }, [tableBody])
    useEffect(() => {
        return () => {
            setIsLoading(true)
            setTableBody([])
        }
    }, [])

    const closePopup = () => {
        setTableBody([])
        setIsLoading(true)
        props.function(false)
    }
    return (
        <FullScreenPopup
            modaltitle={t(
                reports_data && props?.top_api_heading
                    ? `${
                          formik?.values?.report_heading
                              ? formik.values.report_heading.toUpperCase()
                              : reports_data?.topheading
                                ? reports_data.topheading.toUpperCase()
                                : 'REPORT'
                      }`
                    : reports_data
                      ? `${
                            formik?.values?.report_heading
                                ? formik.values.report_heading.toUpperCase()
                                : reports_data.topheading
                        } REPORT`
                      : 'REPORT'
            )}
            open={props.data.popup}
            handleClose={closePopup}
        >
            <div className="fspBody">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    isLoading={isLoading}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={reports_data || []}
                    changeTableFunction={getAllReportDisplay}
                    hideCompactView={props.hideCompactView}
                    columnStorageVariable={'table_report_display_view'}
                />
            </div>
        </FullScreenPopup>
    )
}

export default ReportDisplay
